<template>
    <div class="single-games-tabs">
       <div class="single-games-tab-item"
            :class="{'is-selected' : !selectedMatch}"
            v-if="smallDesktop"
            @click="selectMatch(null)"
        >
            <div class="signle-game-middle-tab">
                <p>{{filtersSelected}}</p>
            </div>
      </div>
      <template v-for="(item, m) in selectedMatches">
        <div class="single-games-tab-item"
        :key="m"
        :class="(selectedMatch != null && item.type === selectedMatch.type && item.id == selectedMatch.id) ? 'is-selected' : ''"
        v-if="smallDesktop || selectedMatches.length > 0">
            <div class="signle-game-left-tab"></div>
            <div v-if="item.type === 'sport' && matchesIn[item.id]" class="signle-game-middle-tab">
                <p v-on:click="selectMatch(item)">{{matchesIn[item.id].teamNameOne}} - {{matchesIn[item.id].teamNameTwo}}</p>
                <i class="iconset icon-close" v-on:click="removeMatchFromTabs(item)"></i>
            </div>
             <div v-else-if="sportState === 'prematch' && item.type === 'outright'" class="signle-game-middle-tab">
                    <p v-on:click="selectMatch(item)">{{outrightName(item.id)}}</p>
                    <i class="iconset icon-close" @click="removeMatchFromTabs(item)"></i>
                </div>
            <div class="signle-game-right-tab"></div>
        </div>
      </template>
    </div>
</template>

<script>

import {
    mapActions,
    mapGetters,
} from 'vuex';

export default {
    name: 'SportTabs',
    props: ['selectedMatches', 'selectedMatch', 'filtersSelected', 'outrights'],
    methods:
    {
        ...mapActions([
            'selectMatch',
            'removeMatchFromSportTabs',
            'removeOutright',
        ]),
        removeMatchFromTabs(item)
        {
            const me = this;

            if (me.connectedOutrights != null && me.connectedOutrights[0] !== undefined)
            {
                let outrightToRemove = null;
                for (const connectedOutright of me.connectedOutrights)
                {
                    for (const outright of connectedOutright.outrights)
                    {
                        if (item.type === 'sport' && outright.shouldRemove)
                        {
                            outrightToRemove = outright;
                            break;
                        }
                        else if (item.type === 'outright' && outright.outrightsOfferId === item.id
                        && (!(outright.status === 'active' || outright.status === 'block')
                        || outright.shouldRemove))
                        {
                            outrightToRemove = outright;
                            break;
                        }
                    }
                }
                if (outrightToRemove !== null)
                {
                    me.removeOutright(outrightToRemove);
                }
            }

            me.removeMatchFromSportTabs(item);
        },
        outrightName(outrightId)
        {
            const me = this;
            let outrightName;

            for (const outright of me.outrights)
            {
                if (outright.outrightsOfferId === outrightId)
                {
                    outrightName = outright.name;
                    break;
                }
            }

            return outrightName;
        },
    },
    computed:
    {
        ...mapGetters([
            'isMobile',
            'smallDesktop',
            'matchesIn',
            'sportState',
            'connectedOutrights',
        ]),
    },
};
</script>
